/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Badge_FailureInputs */

const en_us2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const pt_br2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const es_419_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const pt_pt2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const fr_fr2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const de_de2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V`)
};

const it_it2_workout_logging_badge_failure = /** @type {(inputs: Workout_Logging_Badge_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

/**
* | output |
* | --- |
* | "F" |
*
* @param {Workout_Logging_Badge_FailureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_badge_failure = /** @type {((inputs?: Workout_Logging_Badge_FailureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Badge_FailureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_badge_failure(inputs)
	if (locale === "es-419") return es_419_workout_logging_badge_failure(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_badge_failure(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_badge_failure(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_badge_failure(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_badge_failure(inputs)
	return en_us2_workout_logging_badge_failure(inputs)
});
export { workout_logging_badge_failure as "workout-logging.badge_failure" }